module.exports = __webpack_public_path__ + "media/images/default/shared/header/line-c575c5e4962cb5d5a054999574e0de4d.svg";